export default "__VITE_ASSET__CnBu8ohi__"